import { render } from "./PrizeItem.vue?vue&type=template&id=1685b1a5&scoped=true"
import script from "./PrizeItem.vue?vue&type=script&lang=ts"
export * from "./PrizeItem.vue?vue&type=script&lang=ts"

import "./PrizeItem.vue?vue&type=style&index=0&id=1685b1a5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1685b1a5"

export default script